
import Vue from 'vue'
import { isNil } from 'lodash'

export default Vue.extend({
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    photo: {
      type: [String, Array],
      default: null
    },
    tooltip: {
      type: [String, Object],
      default: null
    },
    content: {
      type: String,
      default: null
    }
  },

  computed: {
    showPhoto() {
      return !isNil(this.photo) || !isNil(this.$slots.photo)
    },

    showHeader() {
      return !isNil(this.title) || !isNil(this.$slots.header)
    },

    prettyContent() {
      return this.$md.render(this.content)
    }
  }
})
